import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'T・Yさん',
    age: '72歳',
    location: '岡山市南区',
    avatar: 'https://public.readdy.ai/ai/img_res/4522612627a5cad51b3218682ec36925.jpg',
    rating: 5,
    title: '一人暮らしでも安心して暮らせるようになりました',
    body: '主人が亡くなってから、庭の草刈りや家の点検が本当に大変で…。息子は大阪にいるので頼めないし、どうしようかと思っていたところ、近所の方に紹介してもらいました。毎月来てくださって、気になるところを全部見てくれるので、今は安心して暮らせています。LINEで写真を送ってくれるので、息子も喜んでいます。',
    service: '庭の手入れ・住居点検',
    period: '利用歴 2年3ヶ月',
    highlight: 'LINEの写真報告で息子も安心',
  },
  {
    id: 2,
    name: 'Y・Kさん',
    age: '68歳',
    location: '倉敷市',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20elderly%20Japanese%20man%20smiling%20gently%2C%20soft%20natural%20light%2C%20simple%20clean%20background%2C%20portrait%20style%2C%20realistic%20photo&width=80&height=80&seq=t2&orientation=squarish',
    rating: 5,
    title: '水路沿いの家の害虫問題がすっかり解決しました',
    body: '倉敷の水路沿いに住んでいるので、毎年夏になるとムカデやゴキブリが大量に出て困っていました。おまかせパックに入ってから、予防処置をしっかりやってもらえるので、今年の夏はほとんど見かけなくなりました。家の点検もしてもらえるので、雨漏りの予兆も早めに見つけてもらえて助かっています。',
    service: '害虫駆除・予防・住居点検',
    period: '利用歴 1年8ヶ月',
    highlight: '夏の害虫がほぼゼロに',
  },
  {
    id: 3,
    name: 'S・Mさん',
    age: '75歳',
    location: '玉野市',
    avatar: 'https://readdy.ai/api/search-image?query=kind%20elderly%20Japanese%20woman%20with%20gentle%20smile%2C%20soft%20natural%20light%2C%20simple%20clean%20background%2C%20portrait%20style%2C%20realistic%20photo&width=80&height=80&seq=t3&orientation=squarish',
    rating: 5,
    title: '遠方の娘が「これで安心」と言ってくれました',
    body: '娘が東京にいるので、家のことが心配だと言っていました。このサービスを始めてから、毎月写真付きで報告が来るので、娘も「お母さんの家の様子がわかって安心」と喜んでいます。スタッフの方がとても丁寧で、話しやすいのも気に入っています。月9,800円でこれだけやってもらえるなら安いものだと思います。',
    service: '清掃・庭の手入れ・点検',
    period: '利用歴 3年1ヶ月',
    highlight: '東京の娘も毎月安心',
  },
  {
    id: 4,
    name: 'N・Kさん',
    age: '55歳',
    location: '神戸市（実家：岡山市中区）',
    avatar: 'https://readdy.ai/api/search-image?query=middle-aged%20Japanese%20man%20smiling%20confidently%2C%20soft%20natural%20light%2C%20simple%20clean%20background%2C%20portrait%20style%2C%20realistic%20photo&width=80&height=80&seq=t4&orientation=squarish',
    rating: 5,
    title: '離れて暮らす親の家を任せられる安心感が違います',
    body: '神戸に住んでいて、岡山の実家に一人で住む母のことがずっと心配でした。帰省するたびに草が伸び放題で、家も傷んでいて…。おまかせパックをお願いしてから、毎月LINEで報告が届くので、実家の状態がリアルタイムでわかります。先日は「雨樋が詰まりかけている」と早めに教えてもらえて、大事になる前に直せました。',
    service: '定期点検・庭の手入れ・補修',
    period: '利用歴 1年2ヶ月',
    highlight: '雨樋の詰まりを早期発見',
  },
  {
    id: 5,
    name: 'N・Sさん',
    age: '80歳',
    location: '岡山市東区',
    avatar: 'https://readdy.ai/api/search-image?query=warm%20elderly%20Japanese%20woman%20with%20kind%20expression%2C%20soft%20natural%20light%2C%20simple%20clean%20background%2C%20portrait%20style%2C%20realistic%20photo&width=80&height=80&seq=t5&orientation=squarish',
    rating: 5,
    title: '足腰が弱くなっても、家がきれいに保てています',
    body: '80歳になって、庭の草取りや高いところの掃除が体的に無理になってきました。このサービスのおかげで、自分ではできないことを全部やってもらえます。スタッフの方が毎回同じ人で、顔なじみになれるのも安心です。「ここも気になりますよ」と気づいたことを教えてくれる心遣いが嬉しいです。',
    service: '清掃・庭の手入れ・小規模補修',
    period: '利用歴 4年',
    highlight: '同じスタッフが担当で安心',
  },
  {
    id: 6,
    name: 'H・Tさん',
    age: '63歳',
    location: '総社市',
    avatar: 'https://readdy.ai/api/search-image?query=relaxed%20middle-aged%20Japanese%20man%20smiling%2C%20soft%20natural%20light%2C%20simple%20clean%20background%2C%20portrait%20style%2C%20realistic%20photo&width=80&height=80&seq=t6&orientation=squarish',
    rating: 5,
    title: '初月980円のお試しで即決しました',
    body: 'キャンペーンで初月980円と聞いて、「試しに」と思って申し込みました。来てもらったら、家の気になる箇所を丁寧にチェックしてくれて、報告書もしっかりしていて感動しました。そのままずっと継続しています。月1万円以下でこれだけのサービスが受けられるのは、本当にコスパが良いと思います。',
    service: '住居点検・害虫予防',
    period: '利用歴 10ヶ月',
    highlight: 'お試し980円で即決・継続中',
  },
];

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const visibleCount = 3;

  const handlePrev = () => {
    setActiveIndex((prev) => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => Math.min(testimonials.length - visibleCount, prev + 1));
  };

  const visibleTestimonials = testimonials.slice(activeIndex, activeIndex + visibleCount);

  return (
    <section id="testimonials" aria-label="お客様の声" className="py-20 md:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-amber-700 text-sm font-semibold tracking-widest mb-3 uppercase">
            お客様の声
          </span>
          <h2
            className="text-2xl md:text-4xl font-black text-stone-800 leading-tight"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            岡山県南部の皆さまから<br />たくさんのご感想をいただいています
          </h2>
          <p className="mt-4 text-stone-500 text-sm md:text-base max-w-xl mx-auto">
            創業15年・地域密着で積み重ねてきた信頼の声をご紹介します。
          </p>

          {/* Stats */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-10 mt-8">
            {[
              { num: '98%', label: '継続率' },
              { num: '4.9', label: '平均評価（5点満点）' },
              { num: '500件+', label: '累計対応件数' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <p className="text-2xl md:text-3xl font-black text-amber-600" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {s.num}
                </p>
                <p className="text-stone-500 text-xs mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Desktop: 3-column grid */}
        <div className="hidden md:grid grid-cols-3 gap-6">
          {visibleTestimonials.map((t) => (
            <TestimonialCard key={t.id} testimonial={t} />
          ))}
        </div>

        {/* Desktop navigation */}
        <div className="hidden md:flex justify-center items-center gap-4 mt-8">
          <button
            onClick={handlePrev}
            disabled={activeIndex === 0}
            className="cursor-pointer w-10 h-10 flex items-center justify-center rounded-full border border-stone-200 text-stone-500 hover:bg-stone-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          >
            <i className="ri-arrow-left-s-line text-lg"></i>
          </button>
          <div className="flex gap-2">
            {Array.from({ length: testimonials.length - visibleCount + 1 }).map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`cursor-pointer w-2 h-2 rounded-full transition-colors ${
                  i === activeIndex ? 'bg-amber-600' : 'bg-stone-200'
                }`}
              />
            ))}
          </div>
          <button
            onClick={handleNext}
            disabled={activeIndex >= testimonials.length - visibleCount}
            className="cursor-pointer w-10 h-10 flex items-center justify-center rounded-full border border-stone-200 text-stone-500 hover:bg-stone-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          >
            <i className="ri-arrow-right-s-line text-lg"></i>
          </button>
        </div>

        {/* Mobile: vertical stack */}
        <div className="md:hidden flex flex-col gap-5">
          {testimonials.map((t) => (
            <TestimonialCard key={t.id} testimonial={t} />
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center bg-amber-50 rounded-2xl p-8 border border-amber-100">
          <p className="text-stone-700 font-semibold text-base md:text-lg mb-1" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            あなたも「おまかせ」してみませんか？
          </p>
          <p className="text-stone-500 text-sm mb-5">
            初月980円のお試しキャンペーン実施中。まずはお気軽にご相談ください。
          </p>
          <button
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="cursor-pointer whitespace-nowrap inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white font-bold px-8 py-3 rounded-full text-sm transition-colors"
          >
            <i className="ri-phone-line"></i>
            無料相談・お問い合わせ
          </button>
        </div>
      </div>
    </section>
  );
}

type Testimonial = typeof testimonials[number];

function TestimonialCard({ testimonial: t }: { testimonial: Testimonial }) {
  return (
    <div className="bg-stone-50 rounded-2xl p-6 border border-stone-100 flex flex-col gap-4">
      {/* Stars */}
      <div className="flex gap-0.5">
        {Array.from({ length: t.rating }).map((_, i) => (
          <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
        ))}
      </div>

      {/* Highlight badge */}
      <div className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 text-xs font-semibold px-3 py-1 rounded-full w-fit">
        <i className="ri-double-quotes-l text-amber-500"></i>
        {t.highlight}
      </div>

      {/* Title */}
      <h3 className="text-stone-800 font-bold text-sm leading-snug" style={{ fontFamily: "'Noto Serif JP', serif" }}>
        {t.title}
      </h3>

      {/* Body */}
      <p className="text-stone-600 text-xs leading-relaxed flex-1">
        {t.body}
      </p>

      {/* Divider */}
      <div className="border-t border-stone-200 pt-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-stone-200">
            <img
              src={t.avatar}
              alt={t.name}
              className="w-full h-full object-cover object-top"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-stone-800 font-bold text-sm">{t.name}（{t.age}）</p>
            <p className="text-stone-400 text-xs">{t.location}</p>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 mt-3">
          <span className="bg-white border border-stone-200 text-stone-500 text-xs px-2 py-0.5 rounded-full">
            {t.service}
          </span>
          <span className="bg-white border border-stone-200 text-stone-500 text-xs px-2 py-0.5 rounded-full">
            {t.period}
          </span>
        </div>
      </div>
    </div>
  );
}
